export default __webpack_public_path__ + "static/media/bonanza.6897042b.webp";